import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import LocalStorageService from "../core/services/local-storage.service";
import { getAccountsUrl } from "../utils/accountsUrl";

const localStorageService = LocalStorageService.getService();

const RouteGuard = ({ children }) => {
  const history = useHistory();
  const location = useLocation();

  const isPublicRoute = (pathname) => {
    if (!pathname) return false;
    const publicRoutes = ["/help-center", "/faqs", "/free-trial"];

    return publicRoutes.some((route) => pathname.startsWith(route));
  };

  useEffect(() => {
    const accessToken = localStorageService.getAccessToken();
    const pathname = location?.pathname || window.location.pathname;
    if (!accessToken && !isPublicRoute(pathname)) {
      localStorageService.clearCompleteStorage();
      window.location.href = getAccountsUrl() + "?&authentication=false";
      return;
    }
    if (accessToken) {
      window.history.pushState(null, "", window.location.href);

      const handlePopState = () => {
        const currentToken = localStorageService.getAccessToken();

        if (!currentToken) {
          window.history.pushState(null, "", window.location.href);
          window.location.href = getAccountsUrl() + "?&authentication=false";
          return;
        }
        window.history.pushState(null, "", window.location.href);
      };

      window.addEventListener("popstate", handlePopState);

      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    }
  }, [location?.pathname, history]);

  return <>{children}</>;
};

export default RouteGuard;
